import api from './api';
import { getConsultantIdentifier } from '../Redux/UsersDucks'
import ErrorService from './errorService';
import Swal from 'sweetalert2';


export const ContractService = {

    cancelContract: async (requestBody) => {


        const consultantIdentifier = getConsultantIdentifier();
        if (!consultantIdentifier) 
            throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
        

        requestBody.createdBy = consultantIdentifier;
        try {
            const response = await ErrorService.withTimeout(api.post('/Contract/Cancel', requestBody));
            return response.data;
        } catch (error) {
            // Manejar errores
            ErrorService.handleApiError('Error al enviar la actualizacion del negocio a HubSpot:', error);
            throw error;
        }
    },

};



export default ContractService;
